module.exports = __webpack_public_path__ + "static/media/work-3.1b9a2c6a.png";